export const TOGGLE_LIST_DETAILS = 'TOGGLE_LIST_DETAILS'
